import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { api_Routes } from "../../../tools/api_Routes";
import { Helper } from "../../../tools/Helper";
import { LinearProgress, TableSortLabel } from "@mui/material";
import { AddButton } from "../../Button/AddButton";
import DeletePops from "../../Pops/DeletePops";
import { setId, setValueConfirm } from "../../../Redux/DeleteReducer";
import { useDispatch, useSelector } from "react-redux";
import { setOpen } from "../../../Redux/ModalReducer";
import AddShopModal from "./add-shop-modal";
import DataTable from "./data-table";
import jsPDF from "jspdf"; // Import jsPDF
import Button from "@mui/material/Button"
import {Can} from "../../Can";


export const TableShopAds = () => {
  const [data, setData] = useState([]);
  const [loading, setLoader] = useState(true);
  const [update, setUpdate] = useState(false);
  const [RefreshData, setRefreshData] = useState(false);
  const [open, setopen] = useState(false);
  const [our_service_id, set_our_service_id] = useState();
  const [service, set_service] = useState();
  const Refresh = useSelector((state) => state.Delete.Refresh);
  const [orderBy, setOrderBy] = useState("id");
  const [orderDirection, setOrderDirection] = useState("asc");
  const [formData, setFormData] = useState({
    type: "",
    price: "",
    countTicket: 0,
    order:0
  });

  const dispatch = useDispatch();

  useEffect(() => {
    get_Services();
  }, [Refresh, RefreshData]);

  const get_Services = async () => {
    const { response, message } = await Helper.Get({
      url: api_Routes.ShopAds.View,
      hasToken: true,
    });
    if (response) {
      setData(response.data);
      setLoader(false);
    }
  };
  const handleEdit = (id) => {
    alert(`Edit clicked for service ID: ${id}`);
  };
  const handleDelete = (id) => {
    dispatch(setValueConfirm("ourService"));
    dispatch(setId(id));
    dispatch(setOpen(true));
  };
  const handleAddType = ($service) => {
    setFormData({ type: "", price: "", days: "", countTicket: "", order: "" });
    set_our_service_id($service.id);
    set_service($service);
    setUpdate(false);
    setopen(true);
    dispatch(setOpen(true));
  };
  const handleEditType = ($type) => {
    setFormData({
      type: $type.type,
      price: $type.price,
      countTicket: $type.countTicket,
      days: $type.days,
      order: $type.order,
      id: $type.id,
    });
    setUpdate(true);
    setopen(true);
    dispatch(setOpen(true));
  };
  const handleDeleteType = ($id) => {
    dispatch(setValueConfirm("type"));
    dispatch(setId($id));
    dispatch(setOpen(true));
  };
  const handleClosePop = () => {
    setopen(false);
    dispatch(setOpen(false));
  };
  const handleSort = (column) => {
    const isAsc = orderBy === column && orderDirection === "asc";
    setOrderBy(column);
    setOrderDirection(isAsc ? "desc" : "asc");
  };
  const sortedData = data.sort((a, b) => {
    if (orderDirection === "asc") {
      return a[orderBy] > b[orderBy] ? 1 : -1;
    }
    return a[orderBy] < b[orderBy] ? 1 : -1;
  });
  const handleExportPDF = () => {
    const doc = new jsPDF();

    // Title
    doc.text("ShopAds Table", 14, 10);

    // Table columns
    const columns = [
      "Name",
      "Description",
      "Image requierd	",
      "Title requierd	",
      "Description requierd	",
      "Active",


    ];

    // Table rows
    const rows = sortedData.map((item) => [
      item.name,
      item.description,
      item.FiledImage,
      item.FiledTitle,
      item.FiledDescription,
      item.active ? "Yes" : "No",
      new Date(item.created_at).toLocaleDateString(),
    ]);

    // Add table to PDF
    doc.autoTable({
      head: [columns],
      body: rows,
      startY: 20,
    });

    // Save the PDF
    doc.save("ShopAds.pdf");
  };

  return (
    <>
      <div className="w-full flex mb-2 justify-between items-center ">
        <div></div>
        <Can I="store" a="ourServices">
        <AddButton to="/Add-AD" label="Add Advertising" />
        </Can>
      </div>
      {/*<Button*/}
      {/*  variant="contained"*/}
      {/*  color="primary"*/}
      {/*  onClick={handleExportPDF}*/}
      {/*  style={{ marginBottom: "16px" }}*/}
      {/*>*/}
      {/*  Export to PDF*/}
      {/*</Button>*/}
      {loading ? (
        <LinearProgress />
      ) : (
        <>
          <DeletePops />
          <AddShopModal
            show={open}
            handleClose={handleClosePop}
            data={formData}
            setData={setFormData}
            update={update}
            selectedId={our_service_id}
            selectedService={service}
            setShouldRefresh={setRefreshData}
          />
          <TableContainer component={Paper}>
            {sortedData?.length > 0 ? (
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center" sx={{ backgroundColor: "primary.main", color: "white", fontWeight: "bold" }} />

                    {[{ label: "Name", key: "name" }, { label: "Description", key: "description" }, { label: "Image required", key: "FiledImage" }, { label: "Title required", key: "FiledTitle" }, { label: "Description required", key: "FiledDescription" }, { label: "Active", key: "active" }, { label: "Order", key: "order" }, { label: "Actions", key: null }].map((column, idx) => (

                      <TableCell
                        key={idx}
                        align="center"
                        sx={{
                          backgroundColor: "primary.main",
                          color: "white",
                          fontWeight: "bold",
                        }}
                      >
                        {column.key ? (
                          <TableSortLabel
                            active={orderBy === column.key}
                            direction={orderBy === column.key ? orderDirection : "asc"}
                            onClick={() => handleSort(column.key)}
                          >
                            {column.label}
                          </TableSortLabel>
                        ) : (
                          column.label
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((service) => (
                    <DataTable
                      key={service.id}
                      service={service}
                      onEdit={handleEdit}
                      onDelete={handleDelete}
                      onAddType={handleAddType}
                      onEditType={handleEditType}
                      onDeleteType={handleDeleteType}
                    />
                  ))}
                </TableBody>
              </Table>
            ) : (
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <TableCell
                      align="center"
                      sx={{
                        backgroundColor: "primary.main",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      There are no data yet
                    </TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            )

            }
          </TableContainer>
        </>
      )}
    </>
  );
};
